<template>
  <v-container fluid class="docs mt-4">
    <v-row>
      <v-col cols=12 md="10">
        <v-card class="mx-1 mb-1">
          <v-card-text class="pa-5">
            <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table v-if="policy!=null" style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img v-if="logo" :src="logo" height="50"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ policy!=null && policy.policydate ? new Date(policy.policydate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' }) : ''  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0"><b>{{ policy.policyname }}</b></h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table v-if="policy!=null" style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr  v-for="(detail) in policy.details"  v-bind:key="detail._id">
                      <td style="width: 100%; vertical-align: text-top; margin-bottom: 10px;">
                        <div>
                          <p style="margin-top: 30px;margin-bottom: 5px;"><span style="font-size: 13pt; font-weight: bold">{{ detail.detailheading }}</span></p>
                          <p class="text-wrap" style="margin-top: 0;margin-bottom: 0; white-space: pre;"><span style="font-size: 12pt;"  v-html="detail.detailtext"></span></p>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            details: [],
          };
        },
        methods: {
          getLogo(companyid){
            if(companyid==null) return;
            if(companyid=='60a8acb67418a3429476cd42'){
              this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs-logo.png';
            }
            else if(companyid=='60b07f300d820029acae4734'){
              this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh-logo.png';
            }
            return this.logo;   
          }

        },
        computed: {
          ...mapState('MyAccount', ['policy']),
        },
        mounted () {

        },
    };
</script>

<style src="./View.scss" lang="scss"/>
